import {
  section,
  container,
  cardTitle,
  grayColor,
  roseColor,
  coloredShadow
} from "../../../material-kit-pro-react";
import { createStyles } from "@material-ui/core";

const styles = createStyles({
  cardTitle,
  container,
  section: {
    ...section,
    padding: "70px 0px"
  },
  coloredShadow,
  cardDescription: {
    color: grayColor[0]
  },
  cardCategory: {
    marginTop: "10px"
  },
  textRose: {
    color: roseColor[0] + " !important"
  }
});

export default styles;
